import { ROUTES } from './constants';

export const AGREEMENT_GATE_EXEMPT_PATHS = [
  ROUTES.ONBOARD,
  ROUTES.LOGIN,
  ROUTES.BACKEND_LOGIN,
  '/unauthorized',
  '/logout',
];

export function isAgreementGateExemptPath(pathname) {
  if (!pathname) return false;
  return AGREEMENT_GATE_EXEMPT_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
}

/**
 * Incomplete required agreements must not reach protected tenant routes.
 * Users with no requirement (complete !== false) are unaffected.
 */
export function shouldRedirectToOnboard({ pathname, agreementStatus }) {
  if (!agreementStatus || agreementStatus.complete !== false) {
    return false;
  }
  if (isAgreementGateExemptPath(pathname)) {
    return false;
  }
  return true;
}

export function outstandingAgreementTypes(agreementStatus) {
  const agreements = agreementStatus?.agreements || {};
  return Object.keys(agreements).filter(
    (type) => agreements[type]?.required && !agreements[type]?.accepted
  );
}
